import { combineReducers } from 'redux'
import site from 'reducers/Site'
import auth from 'reducers/Auth'
import dashboard from 'reducers/Dashboard'

export default combineReducers({
  site,
  auth,
  dashboard,
})
